import { useEffect } from 'react'

export default function MainScreen() {
  useEffect(() => {
    window.location = `https://login.infowijs.${process.env.INFOWIJS_TLD || 'nl'}`
  }, [])
}
